// One-time Aetna renewal notice: has this user already dismissed it?
//
// Scoped by user id, not by client. A broker representing several Aetna clients
// sees the notice once, and the key stays namespaced so one user's dismissal is
// never read as another's on a shared machine.
//
// The prefix is also referenced by utils/useLogoutHandler.js, which preserves
// these keys while clearing the rest of localStorage - without that the notice
// would come back after every logout.
export const AETNA_NOTICE_KEY_PREFIX = "aetnaRenewalNoticeDismissed";

export const getAetnaNoticeKey = (userId) =>
  `${AETNA_NOTICE_KEY_PREFIX}:${userId ?? ""}`;

/**
 * Fails safe to *dismissed*.
 *
 * A missing userId or a throwing localStorage (private browsing) means we
 * cannot record a dismissal, and a notice that cannot be dismissed would
 * reopen on every mount. Suppressing it is the lesser failure.
 */
export const isAetnaNoticeDismissed = (userId) => {
  if (!userId) {
    return true;
  }

  try {
    return window.localStorage.getItem(getAetnaNoticeKey(userId)) !== null;
  } catch (_) {
    return true;
  }
};

export const markAetnaNoticeDismissed = (userId) => {
  if (!userId) {
    return;
  }

  try {
    window.localStorage.setItem(getAetnaNoticeKey(userId), "1");
  } catch (_) {
    // storage access denied (e.g. private browsing restrictions)
  }
};
